import {Fragment} from 'react';
import cx from 'classnames';

import {Text} from '#component/base';
import {formatCurrency} from '#util/formatCurrency';

import {OrderDetailProps} from './OrderDetail.types';

import {
  orderDetailsBody,
  orderDetailsHeadings,
  orderDetailsProductStatus,
  orderDetailsWrapper,
  orderDetailsWrapperWithStatus,
} from './OrderDetail.css';

const OrderDetail = ({order, isNotUpcomingOrder = false}: OrderDetailProps) => {
  return (
    <div className={cx(isNotUpcomingOrder ? orderDetailsWrapperWithStatus : orderDetailsWrapper)}>
      <div>
        {
          <Text variant="body" className={orderDetailsHeadings}>
            Order details
          </Text>
        }
      </div>
      <div>
        {
          <Text variant="body" className={orderDetailsHeadings}>
            unit price
          </Text>
        }
      </div>
      <div>
        {
          <Text variant="body" className={orderDetailsHeadings}>
            Qty
          </Text>
        }
      </div>
      {isNotUpcomingOrder && (
        <div>
          {
            <Text variant="body" className={orderDetailsHeadings}>
              Status
            </Text>
          }
        </div>
      )}
      <div>
        {
          <Text variant="body" className={orderDetailsHeadings}>
            Cost
          </Text>
        }
      </div>
      {/* second row */}
      {order?.orderItems.map((item, idx) => (
        <Fragment key={idx}>
          <div>
            {
              <Text variant="body" className={orderDetailsBody}>
                {item.productTitle}
              </Text>
            }
          </div>
          <div>
            {
              <Text variant="body" className={orderDetailsBody}>
                {formatCurrency('USD', item.unitPrice)}
              </Text>
            }
          </div>
          <div>
            {
              <Text variant="body" className={orderDetailsBody}>
                {item.quantity}
              </Text>
            }
          </div>
          {isNotUpcomingOrder && (
            <div>
              {
                <Text variant="body" className={cx(orderDetailsBody, orderDetailsProductStatus)}>
                  {item.status}
                </Text>
              }
            </div>
          )}
          <div>
            {
              <Text variant="body" className={orderDetailsBody}>
                {formatCurrency('USD', item.cost ?? 0)}
              </Text>
            }
          </div>
        </Fragment>
      ))}
    </div>
  );
};

export default OrderDetail;
